"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AdminOrder_1 = require("./AdminOrder");
exports.default = AdminOrder_1.AdminOrder;
